import { OFFLINE_STORES,getOfflineStorageDriver } from './offlineStorageAdapter.js';

export async function acquireVisitaEngineLease({userId,empresaId,isCurrent,driver=getOfflineStorageDriver(),now=Date.now,setTimer=setInterval,clearTimer=clearInterval,ttl=120000}) {
    const id=`sync-engine:${empresaId}:${userId}`,owner=crypto.randomUUID();
    const store=OFFLINE_STORES.CONTEXTS;
    const previous=await driver.get(store,id);
    if(!isCurrent()||previous?.expiresAt>now())throw Object.assign(Error('Hay otra ejecución de sincronización.'),{code:'sync_busy'});
    let row={id,kind:'sync_engine_lease',userId:Number(userId),empresaId:Number(empresaId),visitaId:0,scope:`sync:${empresaId}:${userId}`,
        templateVersion:'sync-engine-v1',version:crypto.randomUUID(),owner,expiresAt:now()+ttl};
    const publish=async(next,expected)=>{
        if(driver.publishVisitaContext)return driver.publishVisitaContext(next,expected);
        const saved=await driver.mutate(store,id,current=>(current?.version||'')===expected?next:current);
        if(saved?.version!==next.version)throw Object.assign(Error('Cambió el ejecutor de sincronización.'),{code:'changed'});
        return saved;
    };
    try{row=await publish(row,previous?.version||'');}
    catch(error){if(error?.code==='changed')throw Object.assign(Error('Otra ejecución obtuvo la exclusión.'),{code:'sync_busy'});throw error;}
    let valid=true,closed=false,renewing=null;
    const assert=async()=>{
        const current=await driver.get(store,id);
        if(!valid||closed||!isCurrent()||current?.owner!==owner||current.expiresAt<=now()) {
            valid=false;throw Object.assign(Error('La ejecución ya no conserva su identidad o exclusión.'),{code:'sync_lease_lost'});
        }
    };
    const renew=()=>{
        if(renewing)return renewing;
        renewing=(async()=>{await assert();row=await publish({...row,version:crypto.randomUUID(),expiresAt:now()+ttl},row.version);})()
            .catch(()=>{valid=false;}).finally(()=>{renewing=null;});
        return renewing;
    };
    const timer=setTimer(renew,Math.floor(ttl/3));
    return {assert:async()=>{if(renewing)await renewing;await assert();},
        transfer:async task=>{if(renewing)await renewing;await assert();const result=await task();if(renewing)await renewing;await assert();return result;},
        release:async()=>{clearTimer(timer);if(renewing)await renewing;if(closed)return;closed=true;
            const current=await driver.get(store,id);
            if(current?.owner===owner&&current.version===row.version)await publish({...row,version:crypto.randomUUID(),expiresAt:0},row.version);
        }};
}
